import clsx from "clsx"
import styles from "./MessagesModal.module.scss"

const MessagesAsideListLoader = () => {
  return (
    <div>
      {[...Array(3)].map((i, index) => (
        <div key={index} className={clsx(styles.listLoader)}>
          <div className={clsx("skeletonBlock", styles.listLoader__avatar)} />
          <div>
            <div className={clsx("skeletonBlock", styles.listLoader__name)} />
            <div className={clsx("skeletonBlock", styles.listLoader__txt)} />
          </div>
        </div>
      ))}
    </div>
  )
}

export default MessagesAsideListLoader
